import React from 'react';

interface LineListProps {
    lines: string[];
    className?: string;
}

/**
 * 多条内容按行展示：每条一行、带项目符号，折行时悬挂缩进，便于区分折行与下一条；只有一条时按普通文本展示。
 */
const LineList: React.FC<LineListProps> = ({ lines, className }) =>
    lines.length === 1 ? (
        <span className={className}>{lines[0]}</span>
    ) : (
        <ul className={['m-0 pl-5 list-disc', className ?? ''].join(' ').trim()}>
            {lines.map((line, index) => (
                <li key={index}>{line}</li>
            ))}
        </ul>
    );

export default LineList;
